import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] border-t border-[#2a2a2a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-4 w-fit">
              <div className="w-10 h-10 rounded-lg overflow-hidden border border-green-500/30">
                <img src="/logo.png" alt="SisaTeck" className="w-full h-full object-contain bg-white" />
              </div>
              <span className="font-bold text-base tracking-tight">
                <span className="text-white">Sisa</span>
                <span className="text-green-500">Teck</span>
              </span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
              Professional APK hosting platform for Android developers. Host, share, and track your apps with our reliable infrastructure.
            </p>
            <div className="flex flex-wrap items-center gap-3 mt-5">
              <a
                href="https://wa.me/254793973389?text=Hi,%20I%20want%20to%20host%20my%20Android%20app%20on%20SisaTeck"
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 bg-green-500/10 hover:bg-green-500/20 border border-green-500/20 hover:border-green-500/40 text-green-400 text-xs font-medium px-3 py-2 rounded-lg transition-all"
              >
                <span>💬</span> Contact Support
              </a>
              <a
                href="tel:+254793973389"
                className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-gray-300 text-xs font-medium px-3 py-2 rounded-lg transition-all"
              >
                <span>📞</span> Call Us
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2.5">
              {[
                { to: '/', label: 'Home' },
                { to: '/#features', label: 'Features' },
                { to: '/#how-it-works', label: 'How It Works' },
                { to: '/#use-cases', label: 'Use Cases' },
                { to: '/download', label: 'APKs' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-gray-500 hover:text-green-400 text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Legal & Support</h4>
            <ul className="space-y-2.5">
              {[
                { to: '/privacy-policy', label: 'Privacy Policy' },
                { to: '/contact', label: 'Contact Us' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-gray-500 hover:text-green-400 text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a href="tel:+254793973389" className="text-gray-500 hover:text-green-400 text-sm transition-colors">
                  +254 793 973 389
                </a>
              </li>
              <li>
                <a href="tel:+254717325657" className="text-gray-500 hover:text-green-400 text-sm transition-colors">
                  +254 717 325 657
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#2a2a2a] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-xs">
            © {year} SisaTeck. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs">
            Professional <span className="text-green-500">APK Hosting</span> Platform
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
